<script>
	import { addNotify } from "../../../../scripts/notification";

	export let data;
	import {
		isNewDataChanged,
		isMobile,
		imageSize,
		imageNotifyError,
	} from "../../../../stores/variables";

	let input;
	let files = [];

	// function removeImg(i) {
	// 	$isNewDataChanged = true;
	// 	data.src.splice(i, 1);
	// 	data.src = data.src;

	// 	const dt = new DataTransfer();

	// 	for (let k = 0; k < data.images.length; k++) {
	// 		const file = data.images[k];
	// 		if (i !== k) dt.items.add(file);
	// 	}

	// 	data.images = data.images;
	// 	data.images = dt.files;

	// 	input.files = data.images;
	// }

	function removeOldImg(i) {
		$isNewDataChanged = true;
		// data.oldsrc.splice(i, 1);
		// data.ids.splice(i, 1);
		// data.newData[data.field_name] = data.ids;
		data.newData[data.field_name][i]["ToDelete"] = true;
		data = data;
	}

	function showImage(e) {
		$isNewDataChanged = true;
		let files = Array.from(e.target.files);
		data.images = files;
		data.images.forEach((image) => {
			let reader = new FileReader();
			reader.readAsDataURL(image);
			reader.onload = (b) => {
				data.src.push(b.target.result);
				data.src = [...new Set(data.src)];
			};
		});
	}

	if (data) {
		if (!data.oldsrc) data.oldsrc = [];
		if (!data.src) data.src = [];
		if (!data.ids) data.ids = [];
		if (data.newData) {
			if (!data.newData[data.field_name])
				data.newData[data.field_name] = [];
			data.newData[data.field_name].forEach((item) => {
				data.ids.push(item.id);
				data.oldsrc.push(item.url);
			});
			// data.newData[data.field_name] = data.ids;
		}
	}

	const dt2 = new DataTransfer();
	let _input;

	function uploadHandler(e) {
		let files = Array.from(e.target.files);
		if (files) {
			let names = [];
			Array.from(dt2.files).forEach((file) => {
				names.push(file.name);
			});

			files.forEach((file) => {
				if (file.size > $imageSize) {
					addNotify($imageNotifyError, "error");
				} else {
					if (!names.includes(file.name)) {
						dt2.items.add(file);
						$isNewDataChanged = true;
						let reader = new FileReader();
						reader.readAsDataURL(file);
						reader.onload = (b) => {
							data.src.push(b.target.result);
							data.src = [...new Set(data.src)];
						};
					}
				}
			});
			e.target.files = dt2.files;
		}
	}

	function removeImg(i) {
		$isNewDataChanged = true;
		let files = Array.from(dt2.files);
		dt2.clearData();
		data.src.splice(i, 1);
		files.splice(i, 1);
		files.forEach((file) => {
			dt2.items.add(file);
		});
		_input.files = dt2.files;
		data.src = data.src;
	}
</script>

{#if data}
	<div class="add-image">
		{#if data.name}
			<h3>{data.name}</h3>
		{/if}

		<div class="block__content">
			<div class="block__upload">
				<label class="form__upload-button" title={$imageNotifyError}>
					<input
						type="file"
						bind:this={_input}
						on:change={(e) => uploadHandler(e)}
						multiple
						accept=".png, .jpg, .jpeg"
						name={"clinic_gallery[]"}
					/>
					<span><i /></span>
				</label>
			</div>
			{#if data.oldsrc}
				{#each data.oldsrc as oldimg, i}
					<div
						class="block__image {$isMobile
							? 'mobile'
							: 'not_mobile'} {data.newData[data.field_name][i][
							'ToDelete'
						]
							? 'toDelete'
							: ''}"
					>
						{#if data.newData[data.field_name][i]["ToDelete"]}
							<div class="block__image-toDelete" />
						{/if}
						{#if data.newData[data.field_name][i]["ToDelete"] == true}
							<span
								on:click={() =>
									(data.newData[data.field_name][i][
										"ToDelete"
									] = false)}
							>
								<i class="far fa-check" />
							</span>
						{:else}
							<span on:click={() => removeOldImg(i)}>
								<i class="far fa-trash-alt" />
							</span>
						{/if}
						<img src={oldimg} alt="" />
					</div>
				{/each}
			{/if}
			{#if files}
				{#each data.src as image, i}
					<div
						class="block__image {$isMobile
							? 'mobile'
							: 'not_mobile'}"
					>
						<span on:click={() => removeImg(i)}>
							<i class="fas fa-trash" />
						</span>
						<img src={image} alt="" />
					</div>
				{/each}
			{/if}
		</div>
	</div>
{/if}

<style lang="scss">
	.block {
		margin: 0 0 28px 0;

		&:last-child {
			margin: 0;
		}

		&__description {
			display: flex;
			margin: -6px 0 10px 0;
			color: var(--text-gray);
			font-size: 14px;
			max-width: var(--module-width-1);
		}

		&__content {
			display: flex;
			flex-wrap: wrap;
			margin: 0 -20px -20px 0;

			@media (max-width: 991px) {
				margin: 0;
			}
		}

		&__upload,
		&__image {
			display: flex;
			height: 158px;
			width: 158px;
			margin: 0 20px 20px 0;

			@media (max-width: 991px) {
				margin: 0 5px 5px 0;
				height: auto;
				width: auto;
				flex-basis: calc(25% - 5px);

				&::after {
					content: "";
					padding-top: 100%;
				}
			}
		}

		&__upload {
			> label {
				@media (max-width: 991px) {
					padding: 25% !important;
				}
			}
		}

		&__image {
			display: flex;
			position: relative;
			overflow: hidden;
			cursor: pointer;
			border-radius: 20px;

			&-toDelete {
				position: absolute;
				top: 0;
				left: 0;
				bottom: 0;
				right: 0;
				border: solid 2px var(--color-4);
				border-radius: 20px;
				background: #ff00001c;
				display: flex;
				align-items: center;
				justify-content: center;
				&::before,
				&::after {
					content: "";
					width: 100%;
					height: 2px;
					background: var(--color-4);
					display: flex;
					position: absolute;
				}
				&::before {
					transform: rotate(45deg);
				}
				&::after {
					transform: rotate(-45deg);
				}
			}

			> img {
				height: 100%;
				width: 100%;
				border-radius: 20px;
				object-fit: cover;
			}

			&:hover {
				&::before {
					opacity: 0.2;
				}
				> span {
					display: flex;
				}
			}

			// &::before {
			// 	content: "";
			// 	position: absolute;
			// 	height: 100%;
			// 	width: 100%;
			// 	background: black;
			// 	opacity: 0;
			// }

			> span {
				display: none;
				position: absolute;
				align-items: center;
				justify-content: center;
				right: 12px;
				top: 12px;
				height: 32px;
				width: 32px;

				@media (max-width: 991px) {
					right: calc(
						6px + (12 - 6) * ((100vw - 360px) / (991 - 360))
					);
					top: calc(6px + (12 - 6) * ((100vw - 360px) / (991 - 360)));
					height: calc(
						20px + (32 - 20) * ((100vw - 360px) / (991 - 360))
					);
					width: calc(
						20px + (32 - 20) * ((100vw - 360px) / (991 - 360))
					);
				}
				cursor: pointer;

				&:hover {
					&::before {
						opacity: 0.9;
					}
				}

				> i {
					display: flex;
					font-size: 16px;
					@media (max-width: 991px) {
						font-size: calc(
							10px + (16 - 10) * ((100vw - 360px) / (991 - 360))
						);
					}
					color: var(--text-main-1);
					z-index: 1;
				}
				&::before {
					background: var(--bg-black-1);
					content: "";
					height: 100%;
					width: 100%;
					position: absolute;
					opacity: 0.6;
					border-radius: 4px;
					transition: all 0.1s ease-in;
				}
			}

			&.mobile {
				> span {
					display: flex;
				}
			}
		}
	}

	.cross {
		position: absolute;
		right: 12px;
		top: 12px;
		display: flex;
		align-items: center;
		justify-content: center;
		height: 26px;
		width: 26px;
		cursor: pointer;

		@media (max-width: 991px) {
			top: 6px;
			right: 6px;
		}

		&:hover {
			&::before {
				opacity: 1;
			}
		}

		> i {
			display: flex;
			font-size: 16px;
			color: var(--text-main-1);
			z-index: 1;
		}
		&::before {
			background: var(--bg-black-1);
			content: "";
			height: 100%;
			width: 100%;
			position: absolute;
			opacity: 0.7;
			border-radius: 4px;
			transition: all 0.1s ease-in;
		}
	}

	.add-image {
		display: flex;
		flex-direction: column;

		&__image-wrap {
			height: 148px;
			display: flex;
			border-radius: 6px;
			margin: 0 5px 5px 0;
			width: 148px;
			position: relative;

			@media (max-width: 991px) {
				height: 68px;
				width: 68px;
			}
		}

		&__content {
			display: flex;
			flex-wrap: wrap;

			> label {
				display: flex;
				flex-shrink: 0;
				align-items: center;
				justify-content: center;
				height: 148px;
				width: 148px;
				background: var(--color-1);
				cursor: pointer;
				border-radius: 6px;
				margin: 0 5px 5px 0;

				@media (max-width: 991px) {
					height: 68px;
					width: 68px;
				}

				> input {
					display: none;
				}

				> span {
					height: 50%;
					width: 50%;
					border-radius: 50%;
					border: solid 5px var(--bg-main-1);

					> i {
						height: 100%;
						width: 100%;
						display: flex;
						align-items: center;
						justify-content: center;
						position: relative;

						&::before,
						&::after {
							content: "";
							height: 50%;
							width: 5px;
							background-color: var(--bg-main-1);
						}

						&::after {
							transform: rotate(90deg);
							margin-left: -5px;
						}
					}
				}
			}
		}
	}
</style>
